// extracted by mini-css-extract-plugin
export default {"features":"features__SidebarDefaultView__cFzOb","activeFeature":"activeFeature__SidebarDefaultView__cFzOb"};